import React, { useEffect } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { isNil } from "ramda";
import Form from "./Form";
import VerifyOtpForm from "./VerifyOtpForm";
import SupportRequest from "./SupportRequest";
import MessageScreen from "./MessageScreen";
import { resetToken } from "../actions/recaptchaActions";
import { EMAIL_OTP } from "../constants/RegistrationTypes"; 

const WindowRouter = ({ profileNotFound, profileName, supportOpen, registered, resetToken, verified }) => {
  // Resetting the recaptcha token when the props change
  // since the context switch should always invalidate the token
  useEffect(() => {
    resetToken();
  }, [resetToken, supportOpen]);

  if (supportOpen) {
    return <SupportRequest />;
  }

  if (verified.success){
    return (
        <MessageScreen>
          <FormattedMessage
          id="verified"
          defaultMessage="Your email has been verified. Check your email to create your password."
          />
        </MessageScreen>
    ); 
  }

  if (registered){
    if (registered.type === EMAIL_OTP){ 
      return <VerifyOtpForm
              email={registered.data.email}
              accountId={registered.data.accountId}
             />
    } 
    else {
      return (
        <MessageScreen>
          <FormattedMessage
            id="emailSent"
            defaultMessage="We have sent an email containing a link to your registered email address. Please click that link to complete verification."
          />
        </MessageScreen>
      );
    }
  } 

  if (profileNotFound) {
    if (profileName === undefined || profileName === "") {
      return (
        <MessageScreen>
          <FormattedMessage
            id="noProfileProvided"
            defaultMessage="No self-registration profile provided."
          />
        </MessageScreen>
      );
    }
    return (
      <MessageScreen>
        <FormattedMessage
          id="unknownRegistrationProfile"
          defaultMessage={`Unknown self-registration profile: "{profileName}"`}
          values={{profileName}}
        />
      </MessageScreen>
    );
  }

  return <Form />;
};

const mapStateToProps = state => ({
  supportOpen: state.support.open,
  registered: state.registration.registered,
  profileNotFound: isNil(state.registration.data),
  profileName: state.registration.profileName,
  verified: state.verification.verified
});

const mapDispatchToProps = dispatch => ({
  resetToken: () => dispatch(resetToken())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WindowRouter);
